<template>
  <v-card
    elevation="0"
    class="all-trade-tab rounded-0 pt-3 px-0"
    :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-5'"
  >
    <v-tabs
      v-model="model"
      :background-color="$vuetify.theme.dark ? 'blue-darken-2' : 'white-lighten-5'"
      class="pa-0"
    >
      <v-tab :href="`#tab-2`"> Agreement You Accepted </v-tab>

      <v-tabs-items v-model="model">
        <v-tab-item :value="`tab-2`">
          <v-card class="pt-2" flat :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <ConditionTwoTab></ConditionTwoTab>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-card>
</template>
<script>
import ConditionTwoTab from "./ConditionTwoTab.vue";
export default {
  data() {
    return {
      tab: null,
      model: "tab-1",
    };
  },
  components: {
    ConditionTwoTab,
  },
};
</script>
